await loadComponent('./components/mc-element.js', false);
await loadComponent('./res/mc-shopify.js', false); 
await loadComponent('./res/mc-events.js', false); 

class CartError extends McElement {

  connectedCallback() {
    setTimeout(() => {
      window.addEventListener(MCEVENTS.CART_ERROR, this.onCartError.bind(this));
    });
  }

  onCartError = (e) => {
    const message = e.detail.response?.data?.message || e.detail.message;

    const container = this.querySelector('[data-message]');
    if(container) {
      container.innerText = message;
    }

    const modal = bootstrap.Modal.getOrCreateInstance(this);
    if(!modal) {
      console.warn('CartError: modal not found');
      return;
    }

    modal.show();
  }
}

if (!customElements.get('cart-error')) {
  customElements.define('cart-error', CartError);
}

window.CartError = CartError;